import { TReduxActions } from '../../../types/redux';
import { EPriceAndQualityBalanceActionTypes } from '../../../actions/newReview';
import { TPriceAndQualityBalanceRating } from '../../../types/newReview';
import { ENewReviewForm } from '../../../actions/newReview/newReviewsAction';

export const defaultValue = {
  value: 0,
};

export function priceAndQualityBalanceRatingReducer(
  state: TPriceAndQualityBalanceRating = defaultValue,
  { type, payload }: TReduxActions,
): TPriceAndQualityBalanceRating {
  if (type === EPriceAndQualityBalanceActionTypes.SetRating) {
    return {
      value: payload,
    };
  }

  if (type === ENewReviewForm.Clear) {
    return defaultValue;
  }

  return state;
}
